import { render, staticRenderFns } from "./OkrView.vue?vue&type=template&id=f7d53c1c&scoped=true&"
import script from "./OkrView.vue?vue&type=script&lang=js&"
export * from "./OkrView.vue?vue&type=script&lang=js&"
import style0 from "./OkrView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OkrView.vue?vue&type=style&index=1&id=f7d53c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d53c1c",
  null
  
)

export default component.exports